import { PageDataError } from '#src/shared/error';

// oxlint-disable-next-line typescript/no-unnecessary-type-parameters -- CODE has no parameter to infer from by design: callers explicitly instantiate it (e.g. pageDataErrorHandler<MyPageErrorCode>()) so the returned handler's `error` field is typed to their page-specific error code union. Removing it would widen `error` to `string` and break every call site's ERROR type match.
export function pageDataErrorHandler<CODE extends string>(): (error: unknown) => {
	error: CODE;
	message?: string;
	cause?: unknown;
} {
	return (error: unknown) => {
		if (error instanceof PageDataError) {
			return {
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
				error: error.code as CODE,
				...(error.message ? { message: error.message } : {}),
				...(error.cause ? { cause: error.cause } : {}),
			};
		}
		throw error;
	};
}
